// import native from '@zz-common/native-adapter'
import { Toast } from '@zz-common/zz-ui'
import _toast from './toast'

/**
 * 是否在转转App内
 * @return {Boolean} [description]
 */
function isZZApp() {
  const type = /[?&]type=(\w+)/i.exec(location.href)
  return (
    (type && type.length > 1 && type[1].toLowerCase() === 'zzapp') ||
    window.navigator.userAgent.toLowerCase().indexOf('zhuanzhuan') > 0
  )
}
const isZZ = isZZApp()

/**
 * toast 弹窗
 * @param {Object} opt 选项
 * @param {Function} callback 回调
 */
export function toast(opt, callback) {
  const { msg = '' } = opt
  if (isZZ) {
    Toast({
      ...opt,
      message: msg, // 兼容老的写法
      onClose: callback
    })
  } else {
    _toast(opt.msg, callback)
  }
}
